import Flickity from 'flickity-imagesloaded';
import debounce from 'lodash/debounce';
import raf from 'raf';

export default class Awards {
  constructor() {
    this.$carouselElements = document.querySelectorAll('.js-awards-carousel');
    this.$carouselElements.forEach($el => new Carousel($el));
  }
}


class Carousel {
  constructor($el) {
    this.$carouselElement = $el;

    // Functions
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);

    // Variables
    this.requestId = null;

    // Create the carousel
    this.createCarousel();
  }
  
  /**
   * @function createCarousel
   */
  createCarousel() {
    if (this.$carouselElement) {
      this.carousel = new Flickity(this.$carouselElement, {
        cellAlign: 'center',
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: false,
        prevNextButtons: false,
        wrapAround: true,
        paused: true,
        draggable: false,
      });

      this.play();
    }
  }

  /**
   * @function play
   * Plays the marquee
   */
  play() {
    if (!this.carousel) return;

    // Set the decrement of position x
    this.carousel.x = this.carousel.x - 0.5;

    // Settle position into the slider
    this.carousel.settle(this.carousel.x);

    // Set the requestId to the local variable
    this.requestId = raf(this.play);
  }

  /**
   * @function pause
   * Pauses the marquee
   */
  pause() {
    if (!this.requestId || !this.carousel) return;

    // Cancel the animation
    raf.cancel(this.requestId);

    // Reset the this.requestId for the next animation.
    this.requestId = null;
  }
}
